import {ResidenceType} from "features/search/filters/enums";

export interface ResidenceExplorerSetup {
    constructionForm: ResidenceType;
    currentObjectId?: string;
    pageType: ResidenceExplorerPageType;
    siteId: string;
    stageId: string;
    stageIds: string[];
    stageName: string;
    stageStatus: string;
    vipStart: Date;
    vipEnd: Date;
    hideSoldObjects: boolean;
    hideSoldObjectsInExplorer: boolean;
    sunStudyExternalUrl?: string;
    hasExplorer?: boolean;
}

export interface ResidenceExplorerResponse {
    explorerType: string;
    apts: { [key: string]: ResidenceExplorerApt }
    functions: ResidenceExplorerFunctions;
    settings: ResidenceExplorerSettings;
    stageId: string;
    sunstudy: ResidenceExplorerSunstudy;
    views: { [key: string]: ResidenceExplorerView }
}

export interface ResidenceExplorerApt {
    area: string;
    changetime: string;
    county: string;
    fee: number;
    number: string;
    files: ResidenceExplorerAptFiles;
    floor: number;
    floorplan: string;
    id: string;
    isPublished: boolean;
    municipality: string;
    name: string;
    price: number;
    rooms: number;
    roomsDescription: string;
    size: number;
    status: string;
    typeId: number;
    viewId: string;
}

export interface ResidenceExplorerAptFiles {
    floorPlan3DImage: string;
    floorPlanPdf: string;
    object3DViews: ResidenceExplorer3DViews[];
    balconyViews: string[];
}

export interface ResidenceExplorer3DViews {
    name: string;
    posX: number;
    posY: number;
    url: string;
}

export interface ResidenceExplorerFunctions {
    area: boolean;
    frontpage: boolean;
    linked: boolean;
    movies: boolean;
    slideshow: boolean;
    sun: boolean;
    typeapts: boolean;
    view: boolean;
}

export interface ResidenceExplorerSettings {
    firstView: string;
    projectDataUrl: string;
    projectName: string;
    projectUrl: string;
    sunDataUrl: string;
    viewBoxHeight: number;
    viewBoxWidth: number;
}

export interface ResidenceExplorerSunstudy {
    [key: string]: ResidenceExplorerSunStudyDataContainer;
}

export interface ResidenceExplorerSunStudyDataContainer {
    data: ResidenceExplorerSunstudyData[];
    headline: string;
    id: string;
}

export interface ResidenceExplorerSunstudyData {
    endHour: number;
    files: string[];
    imageCount: number;
    name: string;
    path: string;
    localPath: string;
    startFrame: number;
    startHour: number;
    summer: boolean;
}

export interface ResidenceExplorerView {
    clickArea: Record<number, ResidenceExplorerClickArea>
    compass: string;
    description: string;
    groupName: string;
    imageSrc: string;
    interLink: { [key: string]: ResidenceExplorerInterLink };
    linked: boolean;
    localHiResImageSrc: string;
    localImageSrc: string;
    name: string;
    parentViewId: string;
    viewId: string;
}

export interface ResidenceExplorerClickArea {
    coords: string;
    type: string;
    value: string;
    extColor: string;
    extDescription: string;
}

export interface ResidenceExplorerInterLink {
    direction: string;
    name: string;
    type: string;
    value: string;
}


export enum ResidenceExplorerPageType {
    STAGE = 'stage',
    OBJECT = 'object',
    AREA = 'area',
}


export interface ResidenceExternalLinkerResponse {
    explorerType: string;
    stageId: string;
    stageUrl: string;
    stageExternalUrl: string;
    stageImage: string;
    explorerUrl: string;
    objects: ResidenceExternalLinkerObject[];
}

export interface ResidenceExternalLinkerObject {
    number: string;
    url: string;
    imageUrl: string;
}
